// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__QP6dg","h1":"Home_h1__KAfsa","p":"Home_p__O+v6N"};